export default class {
	idProcesso
	inicioValidade
	idOrgao

	constructor(idProcesso, inicioValidade, idOrgao) {
		this.idProcesso = idProcesso
		this.inicioValidade = inicioValidade
		this.idOrgao = idOrgao
	}
}
